export default __webpack_public_path__ + "static/media/edu-blue-logo-new.8624b510.png";